import { Item as _Item } from '@studio/design-system/toggle/group';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Titles } from './constants.js';
import type { ItemProps } from './types.js';
import { GridLines } from '#~/control/index.js';

/** `<Item>` component. */
export const Item = ({ className, value, ...props }: ItemProps): ReactElement => (
  <_Item
    className={twMerge(
      'px-4 x-off:text-secondary enabled:hover:x-off:bg-unset enabled:hover:x-off:text-primary x-on:bg-unset',
      className
    )}
    value={value}
    {...props}
  >
    <svg
      aria-label={Titles[value]}
      className='h-16 w-24 fill-none stroke-current'
      role='img'
      viewBox='0 0 24 16'
    >
      <title>{Titles[value]}</title>
      <rect height='15' rx='1.5' width='23' x='0.5' y='0.5' />

      {value === GridLines.Thirds && <path d='M16 0v16M8 0v16M24 10.5H0M24 5.5H0' />}
      {value === GridLines.Center && <path d='M12 0v16M24 8H0' />}
    </svg>
  </_Item>
);
